import isStreamMonkey from '../../utils/isStreamMonkey';

export default class PlanEnrollmentController {
  constructor($rootScope, $state, $scope, $http, User, Account) {
    'ngInject';
    this.rootScope = $rootScope;
    this.account = $rootScope.account;
    this.accountInfo = Account.getBilling();
    this.user = User;
    this.$state = $state;
    this.$http = $http;
    this.isStreamMonkey = isStreamMonkey(this.account.migration_service_id);
    this.numVideos = 0;

    this.$http.get(`${API_ROOT}/account/migration/imports`).then((resp) => {
      this.numVideos = resp.data.length;
    });

    if (this.account.status != 'onboarding') {
      this.$state.go(`complete-migration.success`);
    }

    $rootScope.$on('account-migrated', (data) => {
      this.account.status = data.status;
    });
  }

  openCompleteAccountModal() {
    const { rootScope } = this;
    rootScope.$emit('open-sm-modal');
    // the modal instance lives in top-navbar.js
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/plan-enrollment.js